import React from 'react';
import { motion } from 'framer-motion';

export const CTAButton = ({ text = "Upgrade Now", className = "", icon = true }) => {
  return (
    <motion.a
      href="https://funnelsdone.com/silverfy"
      whileHover={{ scale: 1.02 }}
      whileTap={{ scale: 0.98 }}
      className={`relative inline-flex items-center justify-center gap-2 group ${className}`}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-royal-600 to-royal-400 rounded-xl blur opacity-75 group-hover:opacity-100 transition duration-200"></div>
      <div className="relative w-full inline-flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-royal-600 to-royal-500 rounded-xl text-white font-bold text-lg md:text-xl shadow-[0_0_20px_rgba(37,99,235,0.3)] border border-royal-400/30">
        {icon && <span className="text-2xl transition-transform group-hover:translate-x-1">👉</span>}
        <span>{text}</span>
      </div>
    </motion.a>
  );
};